import { find, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';

import { FontFamily } from '@zocdoc/components/src/typography';
import { breakpoint } from '@zocdoc/components/src/grid';

import { Markdown, MDButton } from '../../../../Shared/utils/CustomMarkdown';

const StyledMarkdown = styled(Markdown)`
    ${MDButton} {
        font: 12px/22px ${FontFamily.SharpSansSemibold};
        height: auto;
        margin-top: 16px;
        width: 100%;

        ${breakpoint.xsmall} {
            font-size: 14px;
        }

        ${breakpoint.medium} {
            font-size: 15px;
        }
    }
`;

export class BaseUnbookableSection extends React.Component {
    static propTypes = {
        ab: PropTypes.object,
        carouselLocationId: PropTypes.string,
        provider: PropTypes.object.isRequired,
        trackClickUnbookableCTA: PropTypes.func.isRequired,
    };

    trackClickUnbookableCTA = ev => {
        if (ev.target.tagName === 'A' || ev.target.tagName === 'BUTTON') {
            this.props.trackClickUnbookableCTA(this.props.carouselLocationId);
        }
    };

    render() {
        const {
            carouselLocationId,
            insurance,
            isNewPatient,
            provider,
            theme,
        } = this.props;

        const markdown = get(theme, 'profile.unbookableSection.markdown');
        const definitions = get(theme, 'profile.definitions');
        const location = provider.locations && provider.locations.length
            ? find(provider.locations, l => { return l.id === carouselLocationId; }) || provider.locations[0]
            : { };
        const dataForMarkDown = {
            insurance,
            isExistingPatient: !isNewPatient,
            isNewPatient,
            location: {
                unformattedPhone: (location.phone || '').replace(/\W/g, ''),
                ...location,
                ...location.properties,
            },
            provider: {
                ...provider,
                ...provider.properties,
            },
        };
        return markdown ? (
            <StyledMarkdown
                data={dataForMarkDown}
                definitions={definitions}
                onClick={this.trackClickUnbookableCTA}
                source={markdown}
            />
        ) : null;
    }
}

export default withTheme(BaseUnbookableSection);
